import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[3px] z-[110] origin-left"
    >
      <div className="w-full h-full bg-gradient-to-r from-[#e11d2a] via-[#ff6a00] to-[#ffb347]" />
    </motion.div>
  );
};

export default ScrollProgress;
